export default "__VITE_ASSET__oiShQbw___"